// Pre-mount chrome shared by the three embed elements: a visible loading
// state and a visible, retryable failure state. Both exist because the embeds
// render into the HOST page — an empty div is indistinguishable from a broken
// page there (and was exactly that: the original loading state had no content,
// so a slow or failed config fetch looked like a blank site).

import { Loader2, PhoneCall } from 'lucide-react';
import type { Locale } from '../../src/i18n/config';
import { embedChromeStrings } from './messages';

export function EmbedLoading({ locale }: { locale: Locale }) {
  const s = embedChromeStrings(locale);
  return (
    <div className="booking-loading" aria-busy="true">
      <Loader2 className="booking-loading-icon animate-spin" aria-hidden />
      <p>{s.loading}</p>
    </div>
  );
}

export function EmbedUnavailable({
  locale,
  kind,
  onRetry,
}: {
  locale: Locale;
  kind: 'booking' | 'form';
  onRetry: () => void;
}) {
  const s = embedChromeStrings(locale);
  const title = kind === 'booking' ? s.bookingUnavailableTitle : s.formUnavailableTitle;
  const body = kind === 'booking' ? s.bookingUnavailableBody : s.formUnavailableBody;
  return (
    <div className="booking-step booking-outage" role="alert">
      <PhoneCall className="booking-outage-icon" aria-hidden />
      <h2 className="booking-step-title">{title}</h2>
      <p className="booking-outage-body">{body}</p>
      <button type="button" className="booking-outage-retry" onClick={onRetry}>
        {s.retry}
      </button>
    </div>
  );
}
